module.exports = __webpack_public_path__ + "static/media/provo.2cd1badb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cities/provo.jpg
// module id = 532
// module chunks = 0